export const SessionStorage = {
    set: (key, value) => {
        sessionStorage.setItem(key, JSON.stringify(value));
    },
    get: (key) => {
        const data = sessionStorage.getItem(key);
        if (!data) {
            return null;
        }
        return JSON.parse(data);
    },
    remove: (key) => {
        sessionStorage.removeItem(key);
    },
}
export const getSpotlightStr = (str) => {
  if (!str) return '';
  return str
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
export const setGameId = (game_id) => {
  localStorage.setItem('game_id', game_id)
}

export const getGameId = () => {
  return localStorage.getItem('game_id') || '0'
}

export const getContestUID = (code, type = 0) => {
  const game_id = getGameId()
  if (type === 0) {
    return `${game_id}V${code}`
  } else if (type === 1) {
    const idx = code.indexOf('V');
    const codePart = idx !== -1 ? code.substring(idx + 1) : code;
    return codePart;
  }
}
export const getUserReferralCode = () => {
  return localStorage.getItem('referral_code')
}
export const checkDate = (inputDate) => {
		const now = new Date() && new Date();
		const enteredDate = new Date(inputDate);
		const differenceInHours = Math.abs(enteredDate - now) / (1000 * 60 * 60);
		const isSameDay = now.toDateString() === enteredDate.toDateString();
		const isWithin24Hours = differenceInHours <= 24;
		if (isSameDay) {
			return "Today";
		} else if (enteredDate > now) {
			if (isWithin24Hours) {
				return "Tomorrow";
			} else {
				return "Future Date";
			}
		} else {
			if (isWithin24Hours) {
				return "Yesterday";
			} else {
				return "Past Date";
			}
		}
	};
